import formatSortOrder from "../components/SearchResultsTable/formatSortOrder";
import { showAllQuery } from "./DataContext";
import { FetchDataArgs } from "../utils/fetchData";
import isFacetSearchParam from "../components/SearchForm/isFacetSearchParam";

/*
 * Transform front-end URL search params into args
 * to pass to getData() function.
 */
const composeRequestArgs = (
    searchParams: URLSearchParams
): Omit<FetchDataArgs, "config"> => {
    const query = searchParams.get("query")?.trim() ?? showAllQuery;

    const rawInitialOffset = Number(searchParams.get("start_rank"));
    const offset =
        rawInitialOffset && !isNaN(rawInitialOffset) ? rawInitialOffset : 1;

    const rawSortValue = searchParams.get("sort") ?? "";
    const sort = formatSortOrder(rawSortValue);

    type Facets = {
        [key: string]: string | string[];
    };
    const facets: Facets = {};
    searchParams.forEach((paramValue, paramKey) => {
        if (isFacetSearchParam(paramKey) && paramValue.trim()) {
            if (paramKey in facets) {
                const previousValue = facets[paramKey];
                facets[paramKey] = [...previousValue, paramValue];
            } else {
                facets[paramKey] = paramValue.trim();
            }
        }
    });

    const initialRequest = { query, offset, params: facets, sort };

    return initialRequest;
};

export default composeRequestArgs;
